import { useState } from 'react';
import { useLobbyStore, useSocketStore } from '../../stores/socketStore';

export function LobbyList() {
  const [lobbyCode, setLobbyCode] = useState('');
  const [isJoining, setIsJoining] = useState(false);
  const { setCurrentLobby, setPlayerId, draftName, setDraftName, draftColor } = useLobbyStore();
  const { joinLobby } = useSocketStore();

  const handleJoin = async () => {
    if (!lobbyCode.trim() || !draftName.trim()) return;

    setIsJoining(true);

    try {
      const response = await fetch(`/api/lobbies/${lobbyCode.trim()}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          playerName: draftName.trim(),
          color: draftColor,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to join lobby');
      }

      const data = await response.json();

      setPlayerId(data.playerId);
      joinLobby(data.lobbyId, data.playerId);

      // Fetch lobby details
      const lobbyResponse = await fetch(`/api/lobbies/${data.lobbyId}`);
      const lobby = await lobbyResponse.json();
      setCurrentLobby(lobby);
    } catch (error) {
      console.error('Error joining lobby:', error);
      alert(error instanceof Error ? error.message : 'Failed to join lobby');
    } finally {
      setIsJoining(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
        <input
          data-testid="join-player-name-input"
          type="text"
          value={draftName}
          onChange={e => setDraftName(e.target.value)}
          placeholder="Enter your name"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          maxLength={20}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Game Code</label>
        <input
          data-testid="join-lobby-code-input"
          type="text"
          value={lobbyCode}
          onChange={e => setLobbyCode(e.target.value)}
          placeholder="Enter game code"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <button
        data-testid="join-game-button"
        onClick={handleJoin}
        disabled={!lobbyCode.trim() || !draftName.trim() || isJoining}
        className="w-full py-4 bg-blue-500 text-white rounded-lg font-bold text-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {isJoining ? 'Joining...' : 'Join Game'}
      </button>
    </div>
  );
}
